import React from "react";

import type { ChildProps as Props } from "./EmbeddedContent";

export const DivEmbedder = ({ content }: Props): JSX.Element | null => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
};
